jQuery(document).ready(function($) {
  $('.footer__signup-link').on('click', function() {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', 'VDPTSK']);
  });

  if($('.tab-nav li').length > 0) {
    // initialize first tab to show content and set nav to active
    $('.tab-nav li:first-child').addClass('active');
    $('#'+$('.tab-nav li:first-child').attr('rel')).addClass('active');

    // add click event on tab nav
    $('.tab-nav li').each(function() {
        $(this).on('click', function() {
            $('.tab-nav li').removeClass('active');
            $('.tab-content__item').removeClass('active');
            $('#'+$(this).attr('rel')).addClass('active');
            $(this).addClass('active');
        });
    });
  }
});
 